export default __webpack_public_path__ + "static/media/NewDocument.46aa3e75.svg";